export const environment = {
  name: 'QA',
  production: false,
  apiBaseUrl: 'https://qa-api.actionledgers.com/api',
  externalAuthEnabled: true,
  amplitude: { enabled: false, apiKey: '', replayEnabled: false, replaySampleRate: 0 },
  googleMapsApiKey: 'AIzaSyCEVxx6oaJqH-IBCAIvazfTgJm3VhNtqMQ'
};
